export const referenceNo={label:'申请单号',name:'referenceNo'};
export const s={label:'申请单号',name:'referenceNo'};
export const periodFrom={label:'起始时间',name:'startDate'};
export const to={label:'到',name:'endDate'};
export const status={label:'状态',name:'status'};
export const all={label:'全部'};
export const userGuide={label:'用户指南'};
export const size={label:'大小'};
export const type={label:'类型'};
export const updateDate={label:'更新时间'};
export const downloadCount={label:'下载计数'};
export const operation={label:'操作'};
export const operationDate = {label:'操作时间',name:'operationDate'};
export const operationTime = {label:'操作时间',name:'operationDate'};

//列表共用
export const noIndex={label:'序号'};
export const sNo={label:'S/NO'};

//分页
export const pageOf={label:'共'};
export const pageItems={label:'条'};

//按钮名称共用
export const addButton={label:'添加'};
export const modifyButton={label:'修改'};
export const deleteButton={label:'删除'};
export const viewOperationLogsButton={label:'查看操作日志'};
export const voidButton={label:'撤回'};
export const historyButton={label:'历史'};
export const viewButton={label:'查看'};
export const viewPdfButton={label:'查看发票PDF'};
export const exportButton={label:'导出'};
export const checkIncompletedButton={label:'完整性检查'};
export const exportQRCode={label:'导出二维码列表'};
export const viewDetails={label:'查看详情'};
export const discountButton={label:'折扣'};
export const nextButton={label:'下一页'};
export const resetButton={label:'重置'};
export const previousButton={label:'上一页'};
export const previewButton={label:'预览'};
export const confirmButton={label:'确认'};
export const cancelButton={label:'取消'};
export const rejectButton={label:'拒绝'};
export const saveButton={label:'保存'};
export const submitButton={label:'提交'};
export const searchButton={label:'查询'};
export const expandButton={label:'展开'};
export const closeButton={label:'关闭'};
export const selectButton={label:'选择'};
export const uploadButton={label:'上传'};
export const applyButton={label:'申请'};
export const handleButton={label:'处理'};
export const backButton={label:'返回'};
export const enableButton={label:'启用'};
export const disableButton={label:'禁用'};
export const okButton={label:'确定'};
export const nextItemButton={label:'继续添加'};
export const batchImportButton={label:'批量导入'};
export const printButton={label:'打印'};
export const downloadButton={label:'下载'};
export const refreshButton={label:'刷新'};
export const approveButton={label:'审批'};
export const advancedButton={label:"高级搜索"};
export const basicButton={label:"基本搜索"};
export const downloadTemp={label:"下载模板"};
export const shareButton={label:"分享发票PDF"};
export const debitNoteBtn={label:"开具Debit Note"}
export const creditNoteBtn={label:"开具Credit Note"}
export const refundNoteBtn={label:"开具Refund Note"}
export const invoicePreviewBtn={label:"发票预览"}
export const viewTransDataBtn={label:"查看交易数据"}
export const downloadFailedFiles={label:"下载失败的文件"}
//提示语共用
export const noDataExport={label:'列表没有数据，无法导出'};
export const deleteConfirmTip={label:'是否要删除数据？'};
export const pleaseLoginTip={label:'请先登录！'};
export const confirmTitle={label:'确认'};
export const deleteTitle={label:'删除'};
export const saveConfirm={label:'是否要保存？'};
export const submitConfirm={label:'是否要提交？'};
export const cancelConfirm={label:'是否要取消？'};
export const closeConfirm={label:'是否要关闭？'};
export const voidConfirm={label:'是否要撤销此数据？'};
export const voidTip={label:'是否要撤销此数据？'};
export const pleaseSelect={label:'请选择'};
export const enableData={label:'是否要启用此数据？'};
export const disableData={label:'是否要禁用此数据？'};
export const canNotBeZero={label:'不能为0。'};
export const queryDateCanNotExceedOneYear={label:'查询日期不能为空，查询期间不能超过一年！'};
export const isRequiredTip={label:'必填'};
export const isCanNotEmptyTip={label:' 不允许为空'};
export const lengthMustBeLessThan={label:'长度必须小于'};
export const lengthMustBeGreaterThan={label:'长度必须大于'};
export const notValidEmail={label:'格式不正确'};
export const networkFailed={label:'网络连接失败!'};
export const satisfactionSurvey={label:'是否参加满意度调查？'};
export const enterKeywords={label:'请输入关键字'};


//上传附件
export const supportingDocument={label:'上传附件'};
export const uploadFirstTip={label:'请先上传附件'};
export const operationFailed={label:'操作失败，请再试一次。'};
export const operationSuccess={label:'操作成功！'};

export const step={label:"步骤"};
export const operator={label:"操作人"};
export const operatorTime={label:"操作时间"};
export const approved={label:"已通过"};
export const rejected={label:"已拒绝"};
export const enterOnlyDigits="只能输入数字";
export const applicationDate="申请日期";
export const applicationStatus="申请状态";
export const approveDate="审批日期";
export const waitingTime="等待时间";
export const systemPrompt="系统提示";
export const mobileNumberPreIsRequired="手机号码前缀是必填项";
export const queryResultsAreEmpty="查询结果为空";
export const enterEmailAddress="请输入有效的电子邮箱地址";
export const selectOneRecordTip="请选择一条记录。";
export const prompt="提示";
export const successfullySubmitted="提交成功！";
export const successfullyOperated="操作成功！";
export const operationFailedCommon="操作失败！";
export const start="开始";
export const submitted="已提交";
export const end="结束";
export const approvedOrRejected="已通过/已拒绝";
export const total="合计";
export const checkAll="全选";
export const successfullySaved="保存成功！";
export const isRequired="必填";
export const completed="完成";


export const attachmentName="附件名";
export const isItRequired="是否必传";
export const quantity="数量";
export const fileType="文件类型";
export const viewUploadedAttachment="查看已上传的附件";
export const upload="上传";
export const uploadAttachment="上传附件";
export const fileIsNotAllowedDelete="不允许删除该文件";
export const viewDMS="查看DMS";
export const acknowledgeNO="归属单号";
export const taxAuthority="税务机关";
export const documentType="文件类型";
export const fileName="文件名";
export const dateOfSubmission="提交日期";
export const attachmentTypeIsNotAllowedToUpload="不允许上传该附件类型！";
export const cannotUploadAnEmptyFile="无法上传空文件！";
export const attachmentSizeIsTooLarge="附件太大！";
export const failedToDelete="删除失败！";

export const remarks={label:'备注',name:'remarks'};
export const selectDate={label:'请选择日期'};
export const businessCategory= "业务类型";
export const trackYourStatus= "追踪状态";
export const dateFrom="开始时间";
export const cannotVoidTip="申请状态已更改，请重试。";
export const goodsCode = {label:'商品编码：'};
export const itemLabel = {label:'商品名称：'};


export const tin = {label:"TIN",name:"tin"};
export const name = {label:"名称",name:"name"};

export const clientID = {label:"身份识别码",name:"clientId"};
export const SecretID = {label:"安全识别码",name:"clientSecret"};
export const clientTitle ={label:"LHDNM认证"};
export const operationLog = {label:"操作日志"};

export const pwdIncorrect="密码格式不正确。";
export const contactNumIncorrect="联系电话格式不正确。";
export const pwdHasSpecialCharacter="请不要包含以下特殊字符：/\\“'｛｝[]，：；";
export const pwdHasSpecialCharacter2="不允许输入特殊字符：/\\“'｛｝[]，：；";
export const pwdFormatIncorrect="6-20位数字，至少包含3种大小写字母/数字/特殊字符。";
export const passwordIsDifferentFromNewPassword="确认密码与新密码不同！";
export const newPasswordCanTSetTheSameAsTheOriginalOne="新密码不能设置为与原始密码相同！";
export const accountNotExist="当前账号不存在！";
export const emailNotEmpty="不能为空！";
export const emailIncorrect="格式不正确";
export const otpNotEmpty="OTP不能为空！";
export const otpExpired="OTP已过期！";
export const otpIncorrect="OTP不正确!";
export const invalidOTP="OTP无效";
export const registerSuccess="注册成功，请登录。登录账号：";
export const register="注册";
export const enterYourUserName="请输入您的用户名。";
export const enterYourContactNumber="请输入您的联系电话。";
export const validEmailAddress="请提供有效的邮箱地址作为帐户";
export const emailHasBeenRegistered="邮箱已注册";
export const drawerTip="注意：请选择一家或多家公司查看关联财务数据。";


export const queryDateCannotBeEmpty="查询日期不能为空。";
export const queryPeriodCannotExceed1="查询周期不能超过";
export const queryPeriodCannotExceed2="天。";

export const loading="加载中...";
export const noData='暂无数据';
export const exportDataCannotExceed="导出数据不能超过：";
export const dataExportPleaseWait="数据导出，请稍候......";
export const logTitle="操作日志";
export const saveFailed="保存失败！"
export const basicInfoTaxpayerNoMaintained="纳税人的基本信息尚未得到维护。";
export const failSubmitTryLater="提交失败，请稍后重试。";
export const progressTip="进度：";
export const loginAgain="页面长时间未操作，请重新登录";
export const noPermission="无权限";
export const downloadTaskInitiated='数据下载任务已启动，请稍后在“下载任务”菜单中检查任务的进度';
